const uniqBy = require('lodash/uniqBy');
const isPending = require('./is-pending');

/**
 * Process a stream for a query, filtering pending values and ensuring a full value
 * set is returned on every emission. Maintains the order of the requested paths
 * @param {Observable} stream - the output of a muster `get` query
 * @returns {Observable<Array<PathValue>>} - a stream that will emit any time
 * any of the source paths emits, emitting an array of all the requested paths
 * and their values
 */
function watchAll(stream) {
  let initialValues = null;
  let currentValues = [];
  return stream
    // Grab the initial set of pending/cached values to determine output order
    .do((pathValues) => { initialValues = initialValues || pathValues; })
    // Push updated values into the cache of current values
    .map((pathValues) => (currentValues = getUpdatedValues(currentValues, pathValues)))
    // Only emit once all values have resolved
    .filter((pathValues) => pathValues.every(({ value }) => !isPending(value)))
    // Reorder output values to match the initial order
    .map((pathValues) => initialValues.map(({ path: initialPath }) =>
      pathValues.find(({ path }) => path === initialPath)
    ));

  function getUpdatedValues(existingValues, updatedValues) {
    return uniqBy(updatedValues.concat(existingValues), ({ path }) => path);
  }
}

module.exports = watchAll;
